import { createContext, useContext } from 'react';
import type { Langue } from './index';

/** La langue active et le moyen d'en changer — pour le sélecteur, rien d'autre. */
export const ContexteLangue = createContext<{ langue: Langue; changer: (l: Langue) => void }>({
  langue: 'fr', changer: () => {},
});
export const useLangue = () => useContext(ContexteLangue);
